import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUploadImageMutation = createMutationHook(MembershipsCreatorApiClient.uploadImage, {
  mutationKey: ['uploadImage'],
})
